export enum HttpStatusCode {
  NETWORK_ERROR = -1,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  CONFLICT = 409,
  INTERNAL_SERVER = 500,
  SERVICE_UNAVAILABLE = 503
}

export interface HttpError {
  statusCode: number;
  message: string;
  data?: any;
  name: string;
}
